import React, { useState, useEffect } from 'react';
import { Upload, FileText, Image, File, Trash2 } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'sonner';
import axios from 'axios';

export default function FilesPage() {
  const { api, getToken } = useAuth();
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);

  const loadFiles = () => api('get', '/api/portal/files').then(r => setFiles(r.data.files || []));
  useEffect(() => { loadFiles(); }, []);

  const handleUpload = async (e) => {
    const selected = e.target.files;
    if (!selected.length) return;
    setUploading(true);
    try {
      for (const file of selected) {
        const fd = new FormData();
        fd.append('file', file);
        await axios.post('/api/portal/files/upload', fd, {
          headers: { Authorization: `Bearer ${getToken()}`, 'Content-Type': 'multipart/form-data' }
        });
      }
      toast.success(`${selected.length} bestand(en) geüpload`);
      loadFiles();
    } catch { toast.error('Upload mislukt'); }
    finally { setUploading(false); e.target.value = ''; }
  };

  const getIcon = (type = '') => {
    if (type.startsWith('image')) return <Image className="w-5 h-5 text-blue-400" />;
    if (type.includes('pdf')) return <FileText className="w-5 h-5 text-red-400" />;
    return <File className="w-5 h-5 text-[#94a3b8]" />;
  };

  const fmtSize = (bytes) => bytes < 1024 ? `${bytes}B` : bytes < 1048576 ? `${(bytes / 1024).toFixed(1)}KB` : `${(bytes / 1048576).toFixed(1)}MB`;

  return (
    <div className="max-w-4xl">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white">Bestanden</h1>
        <label className={`flex items-center gap-2 bg-[#D4A017] hover:bg-[#B8860B] text-[#0f172a] font-bold px-4 py-2 rounded-xl text-sm cursor-pointer transition-all ${uploading ? 'opacity-60' : ''}`}>
          <Upload size={16} /> {uploading ? 'Uploaden...' : 'Bestanden uploaden'}
          <input type="file" multiple onChange={handleUpload} className="hidden" disabled={uploading} />
        </label>
      </div>

      {/* Upload zone */}
      <div className="border-2 border-dashed border-white/10 rounded-2xl p-8 text-center mb-6 hover:border-[#D4A017]/40 transition-all">
        <Upload className="w-10 h-10 text-[#475569] mx-auto mb-3" />
        <p className="text-[#94a3b8] text-sm">Sleep bestanden hierheen of gebruik de knop hierboven</p>
        <p className="text-[#475569] text-xs mt-1">Logo's, afbeeldingen, documenten, huisstijl</p>
      </div>

      {/* Files list */}
      {files.length === 0 ? (
        <div className="bg-[#0f172a] rounded-2xl border border-white/5 p-8 text-center">
          <p className="text-[#64748b]">Nog geen bestanden geüpload.</p>
        </div>
      ) : (
        <div className="bg-[#0f172a] rounded-2xl border border-white/5 overflow-hidden">
          <div className="grid grid-cols-4 text-xs font-bold text-[#475569] uppercase px-5 py-3 border-b border-white/5">
            <span className="col-span-2">Bestandsnaam</span><span>Grootte</span><span>Datum</span>
          </div>
          {files.map(f => (
            <div key={f.id} className="grid grid-cols-4 items-center px-5 py-3 hover:bg-white/5 border-b border-white/5 last:border-0 transition-all">
              <div className="col-span-2 flex items-center gap-3">
                {getIcon(f.content_type)}
                <span className="text-white text-sm truncate">{f.filename}</span>
              </div>
              <span className="text-[#64748b] text-sm">{fmtSize(f.size || 0)}</span>
              <span className="text-[#64748b] text-sm">{f.uploaded_at?.slice(0, 10)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
